import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaUserMd, FaHeart, FaAward, FaHandshake } from 'react-icons/fa';
import './About.css';
import aboutImg from '../images/about.jpeg';
import WhyChooseUsImg from '../images/doctors.jpeg';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="page-hero">
        <Container>
          <h1>About Aroghya Radham</h1>
          <p>Compassionate Care, Professional Service, Reliable Support</p>
        </Container>
      </section>

      {/* Our Story */}
      <section className="our-story-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2>Our Story</h2>
              <p>
                Aroghya Radham was founded with a singular mission: to provide compassionate, professional, and
                reliable home nursing services to the residents of Guntur and surrounding areas. Our journey began
                with a deep understanding of the challenges that individuals and families face when
                managing health conditions at home.
              </p>
              <p>
                We recognized the need for high-quality, personalized healthcare services that allow patients to 
                receive the care they need in the comfort and familiarity of their own homes. This realization 
                became the cornerstone of Aroghya Radham, driving our commitment to excellence in home healthcare.
              </p>
            </Col>
            <Col lg={6}>
              <img 
                src={aboutImg}
                alt="Our Story" 
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision-section">
        <Container>
          <Row>
            <Col md={6} className="mb-4">
              <Card className="mission-card h-100">
                <Card.Body>
                  <FaHeart className="section-icon" />
                  <h3>Our Mission</h3>
                  <p>
                    To deliver exceptional home healthcare services that prioritize patient comfort, dignity, 
                    and well-being. We strive to empower individuals and families by providing comprehensive 
                    care solutions tailored to their unique needs.
                  </p>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} className="mb-4">
              <Card className="vision-card h-100">
                <Card.Body>
                  <FaAward className="section-icon" />
                  <h3>Our Vision</h3>
                  <p>
                    To be the most trusted and preferred home healthcare provider in Guntur, setting the 
                    standard for quality, compassion, and innovation in home-based medical care services.
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Our Values */}
      <section className="values-section">
        <Container>
          <h2 className="text-center mb-5">Our Core Values</h2>
          <Row className="g-4">
            <Col lg={3} md={6}>
              <div className="value-card text-center">
                <FaUserMd className="value-icon" />
                <h4>Professionalism</h4>
                <p>Highly trained and certified healthcare professionals</p>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="value-card text-center">
                <FaHeart className="value-icon" />
                <h4>Compassion</h4>
                <p>Caring for patients with empathy and understanding</p>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="value-card text-center">
                <FaHandshake className="value-icon" />
                <h4>Integrity</h4>
                <p>Honest, transparent, and ethical in all our practices</p>
              </div>
            </Col>
            <Col lg={3} md={6}>
              <div className="value-card text-center">
                <FaAward className="value-icon" />
                <h4>Excellence</h4>
                <p>Committed to the highest standards of care</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Why Choose Us */}
      <section className="why-us-section">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="order-lg-2 mb-4 mb-lg-0">
              <h2>Why Choose Aroghya Radham?</h2>
              <ul className="why-list">
                <li>Experienced and certified healthcare professionals</li>
                <li>24/7 availability for emergencies</li>
                <li>Personalized care plans tailored to individual needs</li>
                <li>Comprehensive range of home healthcare services</li>
                <li>Compassionate and respectful care approach</li>
                <li>Affordable and transparent pricing</li>
                <li>Regular monitoring and progress updates</li>
                <li>State-of-the-art medical equipment</li>
              </ul>
            </Col>
            <Col lg={6} className="order-lg-1">
              <img 
                src={WhyChooseUsImg}
                alt="Why Choose Us" 
                className="img-fluid rounded shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default About;
